export const routes = {
  homepage: "/",
  dashboard: "/dashboard",
  portfolio: "/portfolio",
};
